import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import axios from 'axios';
import Authenticated from './routes/Authenticated';
import Unauthenticated from './routes/Unauthenticated';

// Prefer runtime-injected window.ENV.REACT_APP_ENV (from config.js),
// then process.env.REACT_APP_ENV. Default to 'production'.
const currentEnv = window?.ENV?.REACT_APP_ENV || process.env.REACT_APP_ENV || 'production';

const API_URL =
  window?.ENV?.API_URL || process.env.REACT_APP_API_URL ||
  (currentEnv === 'development' ? 'https://api.dev.saydalid.com' : 'https://backend.saydalid.com');

axios.defaults.baseURL = `${API_URL.replace(/\/$/, '')}/api/`;
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  function (config) {
    const overrideCountry = localStorage.getItem("x-country-override");
    if (overrideCountry) {
      config.headers["x-country"] = overrideCountry;
      config.headers["x-country-code"] = overrideCountry;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    const newAccessToken = response.headers["authorization"];

    if (newAccessToken) {
      const token = newAccessToken.split(" ")[1];

      localStorage.setItem("token", token);
    }

    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

function App() {
  const token = sessionStorage.getItem('token');
  return (
    <Router>
        <Routes>
        <Route
            path="*"
            element={token ? <Authenticated /> : <Unauthenticated />}
          />
        </Routes>
    </Router>
  );
}

export default App;
